module.exports = __webpack_public_path__ + "static/img/Beats_Studio3_Wireless.d8c594cf.jpg";